import { createRouter, createWebHistory } from "vue-router";
import { afterEachHook, beforeEachGuard } from "@/router/guards";
import { routes } from "@/router/routes";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior(to) {
    if (to.meta.scrollTop) return { top: 0 };
  },
});

router.beforeEach(beforeEachGuard);
router.afterEach(afterEachHook);

export default router;
